import '../models/availability_time_range'

UC.components.AvailabilityTimeRanges = Backbone.Collection.extend({
  model: UC.components.AvailabilityTimeRange
})
